import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreLabelComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-label/mapfre-label.component';
import { MapfreAlertComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params, RouterModule } from '@angular/router';
import {
  AlertService,
  FormBase,
  FormBaseControlService,
  GetGooglePlaceService,
  ValidateAddressService,
  ErrorMessageService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { BillingDataService } from '../../../../_services/data-services/billing-data.service';
import { UserDataService } from '../../../../_services/data-services/user-data.service';
import { BankAccountService } from '../../../../_services/profile-settings/bank-account.service';
import { StorageServiceObservablesService } from '../../../../_services/storage-service-observables/storage-service-observables.service';
import { MaskAccountNumberPipe } from '../../../../_helpers/_pipes/mask-account-number.pipe';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { FullstateToAbvPipe } from '../../../../_helpers/_pipes/fullstate-to-abv.pipe';
import { Subscription } from 'rxjs';
import { PolicyDataService } from '../../../../_services/data-services/policy-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreAlertComponent, MapfreLabelComponent, MapfreButtonComponent, MapfreIputWithValidationComponent, MaskAccountNumberPipe],
  selector: 'app-new-payment-form',
  templateUrl: './new-payment.component.html',
  styleUrls: ['./new-payment.component.scss'],
  providers: [
    FormBaseControlService,
    MaskAccountNumberPipe,
    FullstateToAbvPipe,
  ],
})
export class NewPaymentComponent implements OnInit, OnDestroy {
  @Input() inputs: FormBase<any>[] = [];
  @Input() checkingInfo: any;
  @Input() bankDetails: any;
  @Input() billingDetails: any;
  @Input() isEFT: any;
  @Input() policy: any;
  @Input() achPay: boolean;
  @Output() achConfrimModal = new EventEmitter();
  policyDetails: any;
  checkAmount = true;
  editAccount = false;
  showCustomAmount = false;
  loading = false;
  newPaymentForm: FormGroup;
  newPaymentRadioForm: FormGroup;
  policyId: string;
  mailingAddress: any;
  storeBankAccount: any;
  changeAddressError: boolean;
  addressInput: string;
  mailingAddressString: string;
  storeCheck = false;
  checkNumber: string;
  loader = false;
  hideCityStateField = true;
  hideMultipleCityStateField = true;
  hideZipcodeField = true;
  cityState = '';
  isZipcodeValid = false;
  isMailingAddSelected = true;
  isPOBoxAddSelected = false;
  isPoBoxZipcodeValid = false;
  hidePoBoxCityStateField = true;
  poBoxCity = '';
  poBoxState = '';
  multipleCityOptionsForPOBox = ['city'];
  hidePOMultipleCityStateField = true;
  multipleCityOptionsForMailing = ['city'];
  invalidRouting: boolean;
  isBankAccount: boolean;
  userDataSubscription: Subscription;
  isMailingAddressValid = true;
  enterAmountlabel = false;
  outstandingBalance: any;
  currentMinAmtDue: any;
  isAcmic: boolean;
  accountTypeInput: FormBase<any> = new FormBase<any>({
    key: 'accountType',
    inputType: 'accountType',
    required: true,
  });

  constructor(
    private maskAccountNumberPipe: MaskAccountNumberPipe,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService,
    private bankAccountService: BankAccountService,
    private billingDataService: BillingDataService,
    private getGooglePlaceService: GetGooglePlaceService,
    private ipt: FormBaseControlService,
    public router: Router,
    private storageService: StorageServiceObservablesService,
    private userDataService: UserDataService,
    private validateAddressService: ValidateAddressService,
    private errorRedirectionService: ErrorRedirectionService,
    private errorMessageService: ErrorMessageService,
    private fullstateToAbvPipe: FullstateToAbvPipe,
    private policyDataService: PolicyDataService,
    private gTagService: GTagService,
    private translate: TranslateService,
    private acmicService: AcmicService
  ) {
    this.isAcmic = false;
  }
  @HostListener('window:keyup', ['$event'])
  OnKeyUpGlobal(event) {
    this.checkMaskValue(event);
  }

  checkMaskValue(event) {
    if (event.target.id == 'newPayment_accountNumber') {
      if (this.MatchMaskValue(event.target.value)) {
        this.newPaymentForm.controls['newPayment_accountNumber'].setValue('');
        this.newPaymentForm.controls[
          'newPayment_confirmAccountNumber'
        ].setValue('');
        this.newPaymentForm.controls['newPayment_accountNumber'].setErrors({
          invalidAccount: true,
        });
      }
    }
    if (event.target.id == 'newPayment_confirmAccountNumber') {
      if (this.MatchMaskValue(event.target.value)) {
        this.newPaymentForm.controls[
          'newPayment_confirmAccountNumber'
        ].setValue('');
        this.newPaymentForm.controls[
          'newPayment_confirmAccountNumber'
        ].setErrors({ invalidConfirmAccount: true });
      }
    }
  }

  MatchMaskValue(val) {
    if (
      val.match('X') ||
      val.match('XX') ||
      val.match('XXX') ||
      val.match('XXXX')
    ) {
      return true;
    } else {
      return false;
    }
  }

  OnClickEditButton(): void {
    this.editAccount = !this.editAccount;
  }

  enterAmount(event) {
    if (event.type == 'focus') {
      this.enterAmountlabel = true;
    } else if (
      event.type == 'focusout' &&
      this.newPaymentRadioForm.controls['otherAmount'].value
    ) {
      this.enterAmountlabel = true;
    } else {
      this.enterAmountlabel = false;
    }
  }

  OnChangeShowCustomAmountField(input): void {
    console.log("ACH payment form :: on change amount : ", input)
    if (input == 'other') {
      this.showCustomAmount = true;
    } else {
      this.showCustomAmount = false;
      if (this.currentMinAmtDue == this.outstandingBalance) {
        const radioButton = document.getElementById(input) as any;
        radioButton.checked = true;
      }
    }
  }

  checkAmountNow(e): void {
    const amount = parseFloat(e.target.value);
    this.checkAmount =
      amount >= 1 && amount <= this.outstandingBalance;
  }

  createBankDetailsObject() {
    if (this.isPOBoxAddSelected) {
      const formControls = this.newPaymentForm.controls;
      this.mailingAddress.streetName = `PO box ${formControls.newPayment_poBoxAddress.value}`;
      this.mailingAddress.city = this.poBoxCity;
      this.mailingAddress.state = this.poBoxState;
      this.mailingAddress.zipCode.code =
        formControls.newPayment_PO_zipCode.value;
    }
    if (this.policyId.length === 10) {
      this.mailingAddress = null;
    }
    const accountHolderName =
      this.newPaymentForm.controls.newPayment_accountName.value;
    const paymentObj = {
      bankAccount: {
        accountHolderName:
          accountHolderName != ''
            ? accountHolderName.trim()
            : accountHolderName,
        routingNumber: {
          digits: this.newPaymentForm.controls.newPayment_routingNumber.value,
        },
        accountNumber: {
          digits: this.newPaymentForm.controls.newPayment_accountNumber.value,
        },
        accountType: this.newPaymentRadioForm.controls['accountType'].value,
        mailingAddress: this.mailingAddress,
      },
      checkNumber:
        this.newPaymentForm.controls.newPayment_checkNumber.value || '',
    };
    return paymentObj;
  }

  getStoreAccountInfo(e): void {
    if (e.target.checked) {
      this.storeCheck = true;
      this.billingDataService.updateBankAccountCheck(true);
    } else {
      this.storeCheck = false;
      this.billingDataService.updateBankAccountCheck(false);
    }
  }

  newPaymentFormSubmit(): void {
    this.loader = true;
    let radioAmount,
      paymentObj = {};
    const nPForm = this.newPaymentForm,
      errorString = 'ACCOUNT_NUMBER_CONFIRM_DO_NOT_MATCH';

    // block of code for replace masking account number with without mask number
    let accountNumber = nPForm.controls['newPayment_accountNumber'].value;
    let confirmAccountNumber =
      nPForm.controls['newPayment_confirmAccountNumber'].value;
    if (
      this.MatchMaskValue(nPForm.controls['newPayment_accountNumber'].value)
    ) {
      accountNumber = this.storeBankAccount.accountNumber.digits;
    }
    if (
      this.MatchMaskValue(
        nPForm.controls['newPayment_confirmAccountNumber'].value
      )
    ) {
      confirmAccountNumber = this.storeBankAccount.accountNumber.digits;
    }

    if (confirmAccountNumber != accountNumber) {
      this.gTagService.triggerFormLink(
        'newPaymentForm',
        'false',
        this.translate.instant('NEWPAYMENT_ACCCOUNT_AND_CONFIRM_NUMBER_MATCH')
      );
      this.loader = false;
      this.alertService.error(errorString);
    } else {
      if (this.newPaymentRadioForm.controls['paymentAmount'].value == 'other') {
        radioAmount = this.newPaymentRadioForm.controls['otherAmount'].value;
      } else {
        radioAmount = this.newPaymentRadioForm.controls['paymentAmount'].value;
      }

      if (nPForm.controls['newPayment_aptNumber'].value) {
        const APT = nPForm.controls['newPayment_aptNumber'].value;
        const finalAPT = APT != '' ? APT.trim() : APT;
        this.mailingAddress['streetName'] =
          this.mailingAddress['streetName'] + ' #' + (finalAPT || '');
      }
      this.changeAddressError = false;
      this.getGooglePlaceService.updateAddress(this.mailingAddress);
      // block of code for reset masking account number with without mask number
      if (
        this.MatchMaskValue(nPForm.controls['newPayment_accountNumber'].value)
      ) {
        this.newPaymentForm.controls['newPayment_accountNumber'].setValue(
          this.storeBankAccount.accountNumber.digits
        );
      }
      if (
        this.MatchMaskValue(
          nPForm.controls['newPayment_confirmAccountNumber'].value
        )
      ) {
        this.newPaymentForm.controls[
          'newPayment_confirmAccountNumber'
        ].setValue(this.storeBankAccount.accountNumber.digits);
      }
      paymentObj = this.createBankDetailsObject();
      paymentObj['paymentAmount'] = parseFloat(radioAmount);
      paymentObj['policyId'] = this.policyId;
      this.billingDataService.updateBillingDetailsEcheck(paymentObj);
      if (this.achPay) {
    console.log("ACH submit: go to confirm screen")

        this.router.navigate(['/make-payment', this.policyId, 'confirm']);
      } else {
        this.router.navigate(['/billing', this.policyId, 'confirm']);
      }
    }
  }

  queryServerForBankDetails(): void {
    this.bankAccountService
      .getBankAccountByEmail(this.storageService.getUserFromStorage())
      .subscribe(
        (bankDetails) => {
          this.storeBankAccount = bankDetails;
        },
        (error) => {
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
  }

  setValues(checkingInfo): void {
    const bDetails = checkingInfo,
      apartmentNo =
        bDetails.mailingAddress && bDetails.mailingAddress.streetName
          ? bDetails.mailingAddress.streetName.includes('|')
            ? bDetails.mailingAddress.streetName.split('|')
            : bDetails.mailingAddress.streetName.split('#')
          : [''],
      address = {
        streetName: apartmentNo[0],
        city: bDetails.mailingAddress ? bDetails.mailingAddress.city : '',
        state: bDetails.mailingAddress
          ? bDetails.mailingAddress.stateCode || bDetails.mailingAddress.state
          : '',
        zipCode: {
          code: bDetails.mailingAddress
            ? bDetails.mailingAddress.zipCode.code
            : '',
        },
      };
    if (bDetails.accountHolderName) {
      bDetails.accountHolderName = bDetails.accountHolderName
        .replaceAll('DEFAULT', '')
        .trim();
    }

    this.newPaymentForm.patchValue({
      newPayment_accountName: bDetails.accountHolderName,
      newPayment_routingNumber: bDetails.routingNumber.digits,
      newPayment_accountNumber: bDetails.accountNumber.digits
        ? this.maskAccountNumberPipe.transform(bDetails.accountNumber.digits)
        : '',
      newPayment_confirmAccountNumber: bDetails.accountNumber.digits
        ? this.maskAccountNumberPipe.transform(bDetails.accountNumber.digits)
        : '',
      newPayment_mailingAddress:
        this.policyId.length !== 10
          ? bDetails.mailingAddress
            ? `${address.streetName}, ${address.city}, ${address.state}, USA`
            : ''
          : '',
      newPayment_aptNumber: apartmentNo[1],
      newPayment_checkNumber: this.checkNumber,
    });

    this.newPaymentForm.controls.newPayment_checkNumber.setValidators([
      Validators.maxLength(5),
      Validators.pattern(/^[0-9]\d*$/),
    ]);

    if (bDetails.accountType && this.newPaymentRadioForm) {
      this.newPaymentRadioForm.patchValue({ accountType: bDetails.accountType });
    }

    this.getGooglePlaceService.updateAddressAbv(address);
    this.getGooglePlaceService.updateAddress(address);
  }

  setDynamicInputValidation(radiobutton: string): void {
    const otherAmount = this.newPaymentRadioForm.controls['otherAmount'],
      validation = '^[0-9]+(.[0-9]{1,2})?'; // needs to be placed in teh regex helper
    if (radiobutton == 'other') {
      otherAmount.setValidators([
        Validators.required,
        Validators.maxLength(20),
        Validators.pattern(validation),
        Validators.min(1),
        Validators.max(this.outstandingBalance),
      ]);
    } else {
      otherAmount.setValidators([
        Validators.maxLength(20),
        Validators.pattern(validation),
      ]);
    }
    otherAmount.setValue('');
    otherAmount.updateValueAndValidity();
  }

  ngOnInit() {
      console.log("ACH form ")
    this.isAcmic = this.acmicService.isACMIC();
    this.storeCheck = false;
    this.loading = true;
    this.activatedRoute.params.subscribe((params: Params) => {
      this.policyId =
        params['policyid'] ||
        (this.policy && this.policy.policynumber.policyNumber);
    });

    this.calculateAmounts();

    this.activatedRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['invalidRouting'] == 'Y') {
        this.invalidRouting = true;
        this.editAccount = true;
      }
    });

    this.newPaymentForm = this.ipt.toFormGroup(this.inputs);

    this.newPaymentRadioForm = new FormGroup({
      checkingNumberAmount: new FormControl(),
      paymentAmount: new FormControl(this.currentMinAmtDue, [
        Validators.required,
        Validators.min(1),
      ]),
      otherAmount: new FormControl(''),
      accountType: new FormControl('CHECKINGL', [Validators.required]),
    });

    this.billingDataService.$billingDetailsEcheck.subscribe(
      (accountResponse) => {
        if (accountResponse && accountResponse.bankAccount) {
          if (accountResponse.policyId === this.policyId) {
            this.storeBankAccount = accountResponse.bankAccount;
            this.checkNumber = accountResponse.checkNumber || '';
            this.setValues(this.storeBankAccount);
          } else {
            this.getPolicyBankAcccount();
          }
          this.loading = false;
        } else {
          this.getPolicyBankAcccount();
          this.loading = false;
        }
      },
      () => (this.loading = false)
    );

    this.getGooglePlaceService.$addressAbv.subscribe((address) => {
      if (address) {
        const m = address;
        let street = [];
        street =
          m.streetName != '' && m.streetName != undefined
            ? m.streetName.split('|')
            : m.streetName;
        const streetName = typeof street == 'object' ? street[0] : street;
        this.mailingAddress = address;
        if (this.mailingAddress && this.isMailingAddSelected) {
          this.isZipcodeValid = true;
          if (
            address.zipCode.code === 'undefined' ||
            address.zipCode.code === ''
          ) {
            this.isZipcodeValid = false;
            this.hideZipcodeField = false;
          } else {
            this.newPaymentForm.patchValue({ newPayment_zipCode: '' });
            this.hideZipcodeField = true;
            this.hideCityStateField = true;
            this.hideMultipleCityStateField = true;
          }
          if (this.policyId.length === 10) {
            this.isZipcodeValid = true;
            this.isPoBoxZipcodeValid = true;
          }
        }
        this.mailingAddressString = `${streetName}, ${m.city}, ${m.stateCode || m.state
          }, USA`;
      }
    });

    this.getGooglePlaceService.$mailingPOBoxAddress.subscribe(
      (addressFields) => {
        if (addressFields) {
          if (
            addressFields.zipcode !== '' &&
            addressFields.city !== '' &&
            addressFields.state !== ''
          ) {
            this.cityState = `${addressFields.city}, ${addressFields.state}`;
            if (this.isMailingAddSelected) {
              this.isZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.mailingAddress.city = addressFields.city[0];
                this.multipleCityOptionsForMailing = addressFields.city;
                this.hideCityStateField = true;
                this.hideMultipleCityStateField = false;
                this.newPaymentForm.patchValue({
                  newPayment_state: addressFields.state,
                });
              } else {
                this.newPaymentForm.patchValue({
                  newPayment_city_state: this.cityState,
                });
                this.mailingAddress.city = addressFields.city;
                this.hideMultipleCityStateField = true;
                this.hideCityStateField = false;
              }
              this.mailingAddress.zipCode.code = addressFields.zipcode;
              this.mailingAddress.state = addressFields.state;
            } else if (this.isPOBoxAddSelected) {
              this.isPoBoxZipcodeValid = true;
              if (Array.isArray(addressFields.city)) {
                this.poBoxCity = addressFields.city[0];
                this.multipleCityOptionsForPOBox = addressFields.city;
                this.newPaymentForm.patchValue({
                  newPayment_PO_state: addressFields.state,
                });
                this.hidePoBoxCityStateField = true;
                this.hidePOMultipleCityStateField = false;
              } else {
                this.poBoxCity = addressFields.city;
                this.newPaymentForm.patchValue({
                  newPayment_PO_city_state: this.cityState,
                });
                this.hidePOMultipleCityStateField = true;
                this.hidePoBoxCityStateField = false;
              }
              this.poBoxState = addressFields.state;
            }
          } else {
            if (this.isMailingAddSelected) {
              this.isZipcodeValid = false;
              this.hideMultipleCityStateField = true;
              this.hideCityStateField = true;
            } else if (this.isPOBoxAddSelected) {
              this.hidePOMultipleCityStateField = true;
              this.hidePoBoxCityStateField = true;
              this.isPoBoxZipcodeValid = false;
            }
          }
        }
      }
    );

    if (this.policyId.length === 10) {
      this.isZipcodeValid = true;
      this.isPoBoxZipcodeValid = true;
    }

    this.validateAddressService.$address.subscribe((resp) => {
      this.addressInput = resp === undefined ? this.mailingAddressString : resp;
    });

    if (this.currentMinAmtDue == this.outstandingBalance) {
      setTimeout(() => {
        const radioButton = document.getElementById(
          'paymentAmount-minimum'
        ) as any;
        radioButton.checked = true;
      }, 50);
    }
  }

  onCityChange(e) {
    const selectedCity = e.target.value;
    if (this.isMailingAddSelected) {
      this.mailingAddress.city = selectedCity;
    } else if (this.isPOBoxAddSelected) {
      this.poBoxCity = selectedCity;
    }
  }

  getPolicyBankAcccount() {
    this.userDataService.$userData.subscribe(
      (billingDetails) => {
        if (billingDetails) {
          if (billingDetails.bankAccountDetails) {
            const checkingInfo = billingDetails.bankAccountDetails.filter(
              (x) => x.policyNumber === this.policyId
            );
            if (checkingInfo && checkingInfo !== null) {
              this.storeBankAccount = checkingInfo[0];
              if (this.storeBankAccount) {
                if (!this.storeBankAccount.mailingAddress) {
                  this.storeBankAccount.mailingAddress = {
                    city: '',
                    state: '',
                    stateCode: '',
                    streetName: '',
                    zipCode: { code: '' },
                  };
                }
                this.storeBankAccount.mailingAddress.state =
                  this.storeBankAccount.mailingAddress.stateCode &&
                    this.storeBankAccount.mailingAddress.stateCode !== ''
                    ? this.storeBankAccount.mailingAddress.stateCode
                    : this.storeBankAccount.mailingAddress.state != undefined
                      ? this.fullstateToAbvPipe.transform(
                        this.storeBankAccount.mailingAddress.state
                      )
                      : '';
                const FinaladdressStr =
                  this.storeBankAccount.mailingAddress.streetName +
                  ',' +
                  this.storeBankAccount.mailingAddress.city +
                  ',' +
                  this.storeBankAccount.mailingAddress.state +
                  ',' +
                  'USA';
                this.validateAddressService.updateAddress(FinaladdressStr);
                this.getGooglePlaceService.updateAddress(FinaladdressStr);
                this.loading = false;
              }

              if (
                this.storeBankAccount &&
                this.storeBankAccount.accountHolderName
              ) {
                this.storeBankAccount.accountHolderName =
                  this.storeBankAccount.accountHolderName.toUpperCase();
                this.setValues(this.storeBankAccount);
                this.loading = false;
              } else {
                this.getUserInfo(billingDetails);
                this.loading = false;
              }
            } else {
              this.getUserInfo(billingDetails);
              this.loading = false;
            }
          }
        }
      },
      () => {
        this.loading = false;
      }
    );
  }

  getUserInfo(userData) {
    let userdata = {};
    const fname = userData
      ? userData.userDetails.firstName != null &&
        userData.userDetails.firstName != undefined
        ? userData.userDetails.firstName
        : ''
      : '';
    const lname = userData
      ? userData.userDetails.lastName != null &&
        userData.userDetails.lastName != undefined
        ? userData.userDetails.lastName
        : ''
      : '';
    const mname = userData
      ? userData.userDetails.middleName != null &&
        userData.userDetails.middleName != undefined
        ? userData.userDetails.middleName
        : ''
      : '';
    let accountHolderName = '';
    if (fname != '') {
      accountHolderName = fname;
    }
    if (mname != '') {
      accountHolderName = accountHolderName + ' ' + mname;
    }
    if (lname != '') {
      accountHolderName = accountHolderName + ' ' + lname;
    }

    if (accountHolderName != '') {
      accountHolderName = accountHolderName.toUpperCase();
    }
    userdata = {
      accountHolderName,
      routingNumber: '',
      accountNumber: { digits: '' },
    };
    this.setValues(userdata);
    this.loading = false;
  }

  selectAddressType(addressType) {
    const formControls = this.newPaymentForm.controls;
    if (addressType === 'mailing-address') {
      this.isMailingAddSelected = true;
      this.isPOBoxAddSelected = false;
      formControls.newPayment_mailingAddress.setValidators([
        Validators.required,
      ]);
      formControls.newPayment_mailingAddress.updateValueAndValidity();
      formControls.newPayment_poBoxAddress.clearValidators();
      formControls.newPayment_poBoxAddress.updateValueAndValidity();
    } else if (addressType === 'poBox-address') {
      this.isMailingAddSelected = false;
      this.isPOBoxAddSelected = true;
      formControls.newPayment_poBoxAddress.setValidators([Validators.required]);
      formControls.newPayment_poBoxAddress.updateValueAndValidity();
      formControls.newPayment_mailingAddress.clearValidators();
      formControls.newPayment_mailingAddress.updateValueAndValidity();
    }
  }

  calculateAmounts() {
    if (this.policy.billingDetails[0] && this.policy.hasPriorYearBalance) {
      this.outstandingBalance =
        this.policy.billingDetails[0].outstandingbalance +
        this.policy.priorYearBalance.theAmount;
    } else {
      this.outstandingBalance =
        this.policy.billingDetails[0].outstandingbalance;
    }

    if (this.policy.billingDetails[0] && this.policy.hasPriorYearBalance) {
      this.currentMinAmtDue =
        this.policy.billingDetails[0].amountStillDue +
        this.policy.priorYearBalance.theAmount;
    } else {
      this.currentMinAmtDue = this.policy.billingDetails[0].amountStillDue;
    }
  }

  isValidMailingAdd(value) {
    this.isMailingAddressValid = value;
  }

  goBack(): void {
    this.policyDataService.clear();
    this.billingDataService.clearBilling();
    this.billingDataService.clearCheckingAccount();
    this.router.navigate(['/make-payment']);
  }

  ngOnDestroy() {
    this.getGooglePlaceService.updateMailingPOBoxAdd(undefined);
  }
}
